var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 10.7496C17.19 10.7496 16.85 10.3996 16.85 9.97961C16.85 9.60961 16.48 8.83961 15.86 8.16961C15.25 7.51961 14.58 7.13961 14.02 7.13961C13.59 7.13961 13.25 6.78961 13.25 6.36961C13.25 5.94961 13.6 5.59961 14.02 5.59961C15.02 5.59961 16.07 6.13961 16.99 7.10961C17.85 8.01961 18.4 9.14961 18.4 9.96961C18.4 10.3996 18.05 10.7496 17.62 10.7496Z",
    fill: "url(#paint0_linear_1346_43014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.23 10.75C20.8 10.75 20.46 10.4 20.46 9.98C20.46 6.43 17.57 3.55 14.03 3.55C13.6 3.55 13.26 3.2 13.26 2.78C13.26 2.36 13.6 2 14.02 2C18.42 2 22 5.58 22 9.98C22 10.4 21.65 10.75 21.23 10.75Z",
    fill: "url(#paint1_linear_1346_43014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 14.95L9.2 16.8C8.81 17.19 8.19 17.19 7.79 16.81C7.68 16.7 7.57 16.6 7.46 16.49C6.43 15.45 5.5 14.36 4.67 13.22C3.85 12.08 3.19 10.94 2.71 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C10.83 13.32 10.94 13.42 11.04 13.52C11.44 13.91 11.45 14.55 11.05 14.95Z",
    fill: "url(#paint2_linear_1346_43014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9701 18.33C21.9701 18.61 21.9201 18.9 21.8201 19.18C21.7901 19.26 21.7601 19.34 21.7201 19.42C21.5501 19.78 21.3301 20.12 21.0401 20.44C20.5501 20.98 20.0101 21.37 19.4001 21.62C19.3901 21.62 19.3801 21.63 19.3701 21.63C18.7801 21.87 18.1401 22 17.4501 22C16.4301 22 15.3401 21.76 14.1901 21.27C13.0401 20.78 11.8901 20.12 10.7501 19.29C10.3601 19 9.9701 18.71 9.6001 18.4L12.8701 15.13C13.1501 15.34 13.4001 15.5 13.6101 15.61C13.6601 15.63 13.7201 15.66 13.7901 15.69C13.8701 15.72 13.9501 15.73 14.0401 15.73C14.2101 15.73 14.3401 15.67 14.4501 15.56L15.2101 14.81C15.4601 14.56 15.7001 14.37 15.9301 14.25C16.1601 14.11 16.3901 14.04 16.6401 14.04C16.8301 14.04 17.0301 14.08 17.2501 14.17C17.4701 14.26 17.7001 14.39 17.9501 14.56L21.2601 16.91C21.5201 17.09 21.7001 17.3 21.8101 17.55C21.9101 17.8 21.9701 18.05 21.9701 18.33Z",
    fill: "url(#paint3_linear_1346_43014)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_43014",
    x1: 15.825,
    y1: 5.59961,
    x2: 15.825,
    y2: 10.7496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1346_43014",
    x1: 17.63,
    y1: 2,
    x2: 17.63,
    y2: 10.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1346_43014",
    x1: 6.67252,
    y1: 2,
    x2: 6.67252,
    y2: 17.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1346_43014",
    x1: 15.7851,
    y1: 14.04,
    x2: 15.7851,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c06560c174aac77bd08a5d0c396c2d9e.svg";
export { ForwardRef as ReactComponent };